// extracted by mini-css-extract-plugin
module.exports = {"vodStyles":"ManagePasses_vodStyles__3XJDq"};